export default __webpack_public_path__ + "static/media/savingsapp.c42d73b5.png";